/* eslint-disable no-unused-expressions */
import {
  put, takeLatest, all, select,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import SOActions, { soActionTypes } from '@Actions/sales/soActions';
import SOServices from '../../services/sales/soServices';
import dailyRunRateActions from '@Actions/inventory/dailyRunRateActions';
import documentUINamesConstant from '@Apis/documentUINamesConstant';

function* _createSO(action) {
  try {
    yield put(SOActions.createSOLoading(true));
    const state = yield select();
    const { user } = state?.UserReducers;
    const amcSalesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.ui_name || 'AMC Sales Order';
    const so = yield SOServices.createSO(action.payload);
    if (so.success) {
      yield put(TrackerActions.trackAction(soActionTypes.CREATE_SO.SUCCESS, so.data));
      notification.open({
        type: 'success',
        message: `${so.data?.[0]?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? amcSalesOrderUIName : so.data?.[0]?.order_type.split('_').join(' ').toProperCase()} successfully created`,
        duration: 4,
        placement: 'top',
      });
      action.callback(so?.data?.[0]);
      yield put(SOActions.createSOLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(SOActions.createSOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(SOActions.createSOLoading(false));
    yield put(TrackerActions.trackAction(soActionTypes.CREATE_SO.ERROR, error));
  }
}

function* createSO() {
  yield takeLatest(soActionTypes.CREATE_SO.REQUEST, _createSO);
}

function* _updateSO(action) {
  try {
    yield put(SOActions.updateSOLoading(true));
    const state = yield select();
    const { user } = state?.UserReducers;
    const so = yield SOServices.updateSO(action.payload);
    if (so.success) {
      const amcSalesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract
        ?.settings?.ui_name || 'AMC Sales Order';
      yield put(SOActions.getSOByIdSuccess(null));
      yield put(TrackerActions.trackAction(soActionTypes.UPDATE_SO.SUCCESS, so.data));
      notification.open({
        type: 'success',
        // message: 'Sales Order successfully updated',
        message: `${so.data?.[0]?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? amcSalesOrderUIName : so.data?.[0]?.order_type.split('_').join(' ').toProperCase()} successfully updated`,
        // message: `${so.data?.[0]?.order_type.split('_').join(' ').toProperCase()} successfully updated`,
        duration: 4,
        placement: 'top',
      });
      action.callback(so);
      yield put(SOActions.updateSOLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(SOActions.updateSOLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(SOActions.updateSOLoading(false));
    yield put(TrackerActions.trackAction(soActionTypes.UPDATE_SO.ERROR, error));
  }
}

function* updateSO() {
  yield takeLatest(soActionTypes.UPDATE_SO.REQUEST, _updateSO);
}

function* _getSO(action) {
  const {
    payload, callback,
  } = action;
  const {
    orgId, tenantId, orderId, status, customerId, page, limit, searchKeyword, fulfillmentStatus, startDate, endDate, departmentId, listScreen, paymentStatus, secondaryStatus, shopifySearchKeyword, tags, accountManagerIds, fromDeliveryDate, toDeliveryDate, fromOrderDate, toOrderDate, isLinkedMrp, orderType, excludeOrderIds, excludeGRNCustomerIds, productSkuIds, sourceTenantId, tenantDepartmentId
  } = payload;
  try {
    SOActions.getSOSuccess(null, orderType);
    yield put(SOActions.getSOLoading(true, orderType));
    const salesOrders = yield SOServices.getSO(orgId, tenantId, orderId, status, customerId, page, limit, searchKeyword, fulfillmentStatus, startDate, endDate, departmentId, listScreen, paymentStatus, secondaryStatus, shopifySearchKeyword, tags, accountManagerIds, fromDeliveryDate, toDeliveryDate, fromOrderDate, toOrderDate, isLinkedMrp, orderType, excludeOrderIds, excludeGRNCustomerIds, productSkuIds, sourceTenantId, tenantDepartmentId);
    yield put(SOActions.getSOSuccess(salesOrders, orderType));
    if (callback) callback(salesOrders);
    yield put(SOActions.getSOLoading(false, orderType));
  } catch (error) {
    yield put(SOActions.getSOLoading(false, orderType));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.GET_SO.ERROR, error));
  }
}

function* getSO() {
  yield takeLatest(soActionTypes.GET_SO.REQUEST, _getSO);
}

function* _getSOById(action) {
  try {
    const { payload, callback } = action;
    const { orgId, tenantId, soId, isReducerNeedToBeEmpty } = payload;
    if (isReducerNeedToBeEmpty) {
      yield put(SOActions.getSOByIdSuccess(null));
    }
    yield put(SOActions.getSOByIdLoading(true));
    const selectedSO = yield SOServices.getSO(orgId, tenantId, soId);
    yield put(SOActions.getSOByIdSuccess(selectedSO?.data?.sales_orders[0] || {}));
    if (callback) {
      callback(selectedSO?.data?.sales_orders[0] || {});
    }
    yield put(SOActions.getSOByIdLoading(false));
  } catch (error) {
    yield put(SOActions.getSOByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.GET_SO_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getSOById() {
  yield takeLatest(soActionTypes.GET_SO_BY_ID.REQUEST, _getSOById);
}

function* _updateSOStatus(action) {
  try {
    yield put(SOActions.updateSOStatusLoading(true));
    const so = yield SOServices.updateSOStatus(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.updateSOStatusLoading(false));
  } catch (error) {
    yield put(SOActions.updateSOStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.UPDATE_STATUS_SO.ERROR, error));
  }
}

function* updateSOStatus() {
  yield takeLatest(soActionTypes.UPDATE_STATUS_SO.REQUEST, _updateSOStatus);
}

function* _updateBundleLines(action) {
  try {
    yield put(SOActions.updateBundleLinesLoading(true));
    const so = yield SOServices.updateBundleLines(action.payload);

    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Bundle lines successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.updateBundleLinesLoading(false));
  } catch (error) {
    yield put(SOActions.updateBundleLinesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.UPDATE_BUNDLE.ERROR, error));
  }
}

function* updateBundleLines() {
  yield takeLatest(soActionTypes.UPDATE_BUNDLE.REQUEST, _updateBundleLines);
}

function* _deleteBundleLines(action) {
  try {
    yield put(SOActions.deleteBundleLinesLoading(true));
    const so = yield SOServices.deleteBundleLines(action.payload);

    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Bundle lines successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.deleteBundleLinesLoading(false));
  } catch (error) {
    yield put(SOActions.deleteBundleLinesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.DELETE_BUNDLE_LINE.ERROR, error));
  }
}

function* deleteBundleLines() {
  yield takeLatest(soActionTypes.DELETE_BUNDLE_LINE.REQUEST, _deleteBundleLines);
}

function* _deleteSO(action) {
  try {
    yield put(SOActions.deleteSOLoading(true));
    const so = yield SOServices.deleteSO(action.payload);

    if (so.success) {
      notification.open({
        type: 'success',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.deleteSOLoading(false));
  } catch (error) {
    yield put(SOActions.deleteSOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.DELETE_SO.ERROR, error));
  }
}

function* deleteSO() {
  yield takeLatest(soActionTypes.DELETE_SO.REQUEST, _deleteSO);
}

function* _updateSOWorkflowStep(action) {
  try {
    yield put(SOActions.updateSOWorkflowStepLoading(true));
    const state = yield select();
    const { user } = state?.UserReducers;
    const salesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.ui_name || 'Sales Order';
    const so = yield SOServices.updateSOWorkflowStep(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: `Order successfully updated`,
        // message: `${so?.order_type.split('_').join(' ').toProperCase()} successfully updated`,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.updateSOWorkflowStepLoading(false));
  } catch (error) {
    yield put(SOActions.updateSOWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.UPDATE_SO_WORKFLOW_STEP.ERROR, error));
  }
}

function* updateSOWorkflowStep() {
  yield takeLatest(soActionTypes.UPDATE_SO_WORKFLOW_STEP.REQUEST, _updateSOWorkflowStep);
}

function* _updateFulfillmentLocation(action) {
  try {
    yield put(SOActions.updateFulfillmentLocationLoading(true));
    const updateLocation = yield SOServices.updateFulfillmentLocation(action.payload);
    if (updateLocation.success) {
      yield put(TrackerActions.trackAction(soActionTypes.UPDATE_FULFILLMENT_LOCATION.SUCCESS, updateLocation.data));
      notification.open({
        type: 'success',
        message: 'Shopify Location successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(updateLocation);
      yield put(SOActions.updateFulfillmentLocationLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: updateLocation?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(SOActions.updateFulfillmentLocationLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(SOActions.updateFulfillmentLocationLoading(false));
    yield put(TrackerActions.trackAction(soActionTypes.UPDATE_FULFILLMENT_LOCATION.ERROR, error));
  }
}

function* updateFulfillmentLocation() {
  yield takeLatest(soActionTypes.UPDATE_FULFILLMENT_LOCATION.REQUEST, _updateFulfillmentLocation);
}

function* _fulfillUnfulfilledOrder(action) {
  try {
    yield put(SOActions.fulfillUnfulfilledOrderLoading(true));
    const fulfill = yield SOServices.fulfillUnfulfilledOrder(action.payload);
    if (fulfill.success) {
      yield put(TrackerActions.trackAction(soActionTypes.FULFILL_UF_FO.SUCCESS, fulfill.data));
      notification.open({
        type: 'success',
        message: 'Order successfully fulfilled',
        duration: 4,
        placement: 'top',
      });
      action?.callback();
      yield put(SOActions.fulfillUnfulfilledOrderLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: fulfill.message,
        duration: 4,
        placement: 'top',
      });
      yield put(SOActions.fulfillUnfulfilledOrderLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(SOActions.fulfillUnfulfilledOrderLoading(false));
    yield put(TrackerActions.trackAction(soActionTypes.FULFILL_UF_FO.ERROR, error));
  }
}

function* fulfillUnfulfilledOrder() {
  yield takeLatest(soActionTypes.FULFILL_UF_FO.REQUEST, _fulfillUnfulfilledOrder);
}

function* _cancelFulfillment(action) {
  try {
    yield put(SOActions.cancelFulfillmentLoading(true));
    const so = yield SOServices.cancelFulfillment(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Fulfillment successfully cancelled',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.cancelFulfillmentLoading(false));
  } catch (error) {
    yield put(SOActions.cancelFulfillmentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.CANCEL_FULFILLMENT.ERROR, error));
  }
}

function* cancelFulfillment() {
  yield takeLatest(soActionTypes.CANCEL_FULFILLMENT.REQUEST, _cancelFulfillment);
}

function* _createReturnFulfillment(action) {
  try {
    yield put(SOActions.createReturnFulfillmentLoading(true));
    const fulfill = yield SOServices.createReturnFulfillment(action.payload);
    if (fulfill.success) {
      yield put(TrackerActions.trackAction(soActionTypes.CREATE_RETURN_FULFILLMENT.SUCCESS, fulfill.data));
      notification.open({
        type: 'success',
        message: 'Return successfully initiated.',
        duration: 4,
        placement: 'top',
      });
      action?.callback();
      yield put(SOActions.createReturnFulfillmentLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: fulfill.message,
        duration: 4,
        placement: 'top',
      });
      yield put(SOActions.createReturnFulfillmentLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(SOActions.createReturnFulfillmentLoading(false));
    yield put(TrackerActions.trackAction(soActionTypes.CREATE_RETURN_FULFILLMENT.ERROR, error));
  }
}

function* createReturnFulfillment() {
  yield takeLatest(soActionTypes.CREATE_RETURN_FULFILLMENT.REQUEST, _createReturnFulfillment);
}

function* _cancelReturnFulfillment(action) {
  try {
    yield put(SOActions.cancelReturnFulfillmentLoading(true));
    const so = yield SOServices.cancelReturnFulfillment(action.payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: 'Returned Fulfillment successfully cancelled',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.cancelReturnFulfillmentLoading(false));
  } catch (error) {
    yield put(SOActions.cancelReturnFulfillmentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.CANCEL_RETURN_FULFILLMENT.ERROR, error));
  }
}

function* cancelReturnFulfillment() {
  yield takeLatest(soActionTypes.CANCEL_RETURN_FULFILLMENT.REQUEST, _cancelReturnFulfillment);
}

function* _getReturnFulfillment(action) {
  try {
    yield put(SOActions.getReturnFulfillmentLoading(true));
    const {
      orderId,
    } = action;
    const salesOrders = yield SOServices.getReturnFulfillment(orderId);
    yield put(SOActions.getReturnFulfillmentSuccess(salesOrders));
    if (salesOrders.success) {
      if (action.callback) {
        action.callback(salesOrders);
      }
    } else {
      notification.open({
        type: 'error',
        message: salesOrders.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.getReturnFulfillmentLoading(false));
  } catch (error) {
    yield put(SOActions.getReturnFulfillmentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.GET_RETURN_FULFILLMENT.ERROR, error));
  }
}

function* getReturnFulfillment() {
  yield takeLatest(soActionTypes.GET_RETURN_FULFILLMENT.REQUEST, _getReturnFulfillment);
}

function* _createRefund(action) {
  try {
    yield put(SOActions.createRefundLoading(true));
    const so = yield SOServices.createRefund(action.payload);
    if (so.success) {
      yield put(TrackerActions.trackAction(soActionTypes.CREATE_REFUND.SUCCESS, so.data));
      notification.open({
        type: 'success',
        message: 'Refund successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(so?.data?.[0]);
      yield put(SOActions.createRefundLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(SOActions.createRefundLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(SOActions.createRefundLoading(false));
    yield put(TrackerActions.trackAction(soActionTypes.CREATE_REFUND.ERROR, error));
  }
}

function* createRefund() {
  yield takeLatest(soActionTypes.CREATE_REFUND.REQUEST, _createRefund);
}

function* _getReturns(action) {
  try {
    yield put(SOActions.getReturnsLoading(true));
    const {
      shopName, shopifyOrderId, orderId,
    } = action;
    const shopifyReturns = yield SOServices.getReturns(shopName, shopifyOrderId, orderId);
    yield put(SOActions.getReturnsSuccess(shopifyReturns));
    yield put(SOActions.getReturnsLoading(false));
  } catch (error) {
    yield put(SOActions.getReturnsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.GET_RETURNS.ERROR, error));
  }
}

function* getReturns() {
  yield takeLatest(soActionTypes.GET_RETURNS.REQUEST, _getReturns);
}

function* _convertSoToMo(action) {
  try {
    yield put(SOActions.convertSoToMoLoading(true));
    const { payload, callback } = action;
    const createMos = yield SOServices.convertSoToMo(payload);
    if (createMos?.success) {
      notification.open({
        type: 'success',
        message: 'Manufacturing Orders have been created successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createMos?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.convertSoToMoLoading(false));
  } catch (error) {
    yield put(SOActions.convertSoToMoLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.CONVERT_SO_TO_MO.ERROR, error));
  }
}

function* convertSoToMo() {
  yield takeLatest(soActionTypes.CONVERT_SO_TO_MO.REQUEST, _convertSoToMo);
}

function* _getSoAvailability(action) {
  try {
    yield put(SOActions.getSoAvailabilityLoading(true));
    const { payload, callback } = action;
    const soLines = yield SOServices.getSoAvailability(payload?.soIds, payload?.tenantId, payload?.tenantDepartmentId, payload?.soLineIds, payload?.mrpId);
    if (soLines?.success) {
      yield put(SOActions.getSoAvailabilitySuccess(soLines?.data));
      if (callback) {
        callback(soLines?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: soLines.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.getSoAvailabilityLoading(false));
  } catch (error) {
    yield put(SOActions.getSoAvailabilityLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.GET_SO_AVAILABILITY.ERROR, error));
  }
}

function* getSoAvailability() {
  yield takeLatest(soActionTypes.GET_SO_AVAILABILITY.REQUEST, _getSoAvailability);
}

// download SO List
function* _downloadSoList(action) {
  try {
    yield put(SOActions.downloadSoListLoading(true));
    const { payload, callback } = action;
    const soList = yield SOServices.downloadSoList(payload);
    if (soList?.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: soList.message,
        duration: 4,
        placement: 'top',
      });
    }
    callback();
    yield put(SOActions.downloadSoListLoading(false));
  } catch (error) {
    yield put(SOActions.downloadSoListLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(soActionTypes.DOWNLOAD_SO_LIST.ERROR, error));
  }
}

function* downloadSoList() {
  yield takeLatest(soActionTypes.DOWNLOAD_SO_LIST.REQUEST, _downloadSoList);
}

// unlink SO and MO

function* _unlinkMOFromSo(action) {
  try {
    yield put(SOActions.unLinkMOFromSOLoading(true));
    const { payload, callback } = action;
    const state = yield select();
    const { user } = state?.UserReducers;
    const salesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.ui_name || 'Sales Order';
    const unlink = yield SOServices.unlinkMOFromSo(payload);
    if (unlink?.success) {
      notification.open({
        type: 'success',
        message: `${salesOrderUIName} and Manufacturing Order successfully unlinked`,
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: unlink.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(SOActions.unLinkMOFromSOLoading(false));
  } catch (error) {
    yield put(SOActions.unLinkMOFromSOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* unlinkMOFromSo() {
  yield takeLatest(soActionTypes.UNLINK_MO_SO.REQUEST, _unlinkMOFromSo);
}

// quick update SO
function* _quickUpdateSO(action) {
  try {
    const state = yield select();
    const { selectedSO } = state?.SOReducers;
    const { user } = state?.UserReducers;
    const amcSalesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.annual_maintenance_contract?.settings?.ui_name || 'AMC Sales Order';
    let copySo = JSON.parse(JSON.stringify(selectedSO));
    const copySoSecondary = JSON.parse(JSON.stringify(selectedSO));
    copySo = { ...copySo, ...action.payload };
    yield put(SOActions.getSOByIdSuccess(copySo));
    yield put(SOActions.quickUpdateSOLoading(true));
    const { payload, callback, rollback } = action;
    const so = yield SOServices.quickUpdateSO(payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: `${so?.order_type ? so?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? amcSalesOrderUIName : so?.order_type.split('_').join(' ').toProperCase() : ''} successfully updated`,
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
      if (rollback) {
        rollback();
      }
      yield put(SOActions.getSOByIdSuccess(copySoSecondary));
    }
    yield put(SOActions.quickUpdateSOLoading(false));
  } catch (error) {
    yield put(SOActions.quickUpdateSOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* quickUpdateSO() {
  yield takeLatest(soActionTypes.QUICK_UPDATE_SO.REQUEST, _quickUpdateSO);
}

export default function* soSaga() {
  yield all([
    createSO(), getSO(), updateSO(), getSOById(), updateSOStatus(), deleteSO(), quickUpdateSO(),
    updateSOWorkflowStep(), updateFulfillmentLocation(), fulfillUnfulfilledOrder(),
    cancelFulfillment(), cancelReturnFulfillment(), createReturnFulfillment(),
    getReturnFulfillment(), createRefund(), getReturns(), updateBundleLines(),
    deleteBundleLines(), convertSoToMo(), getSoAvailability(), downloadSoList(), unlinkMOFromSo(),
  ]);
}
